/**
 * Determina se um arquivo pode ser visualizado direto no navegador (PDF ou
 * imagem), a partir da extensão do nome do arquivo — é o dado que já
 * temos disponível na hora de montar a lista, sem precisar baixar o
 * conteúdo só para descobrir o tipo.
 */
export type PreviewKind = 'pdf' | 'image';

const IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.bmp', '.svg'];
const PDF_EXTENSION = '.pdf';

export const getPreviewKind = (fileName: string | undefined | null): PreviewKind | null => {
  if (!fileName) return null;

  const lower = fileName.toLowerCase();

  if (lower.endsWith(PDF_EXTENSION)) return 'pdf';
  if (IMAGE_EXTENSIONS.some((ext) => lower.endsWith(ext))) return 'image';

  return null;
};

/** Estado do modal de visualização de documento (ver hooks/useDocumentPreview). */
export interface DocumentPreviewState {
  show: boolean;
  url: string | null;
  kind: PreviewKind | null;
  title: string;
}

export const INITIAL_DOCUMENT_PREVIEW_STATE: DocumentPreviewState = {
  show: false,
  url: null,
  kind: null,
  title: '',
};
